module.exports = __webpack_public_path__ + "static/media/user.9ddbe23b.svg";